import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import classNames from 'classnames';
import TinyPopover from '../../../components/TinyPopover';
import { CheckboxCheckedIcon, WarningIcon, InfoIcon, CircledCross } from '../../../components/Icons';
var POPOVER_CONTAINER_STYLE = {
  overflow: 'visible',
  zIndex: 2
};
var POPOVER_BUTTON_STYLE = {
  marginTop: 2
};
var POPOVER_CONTENT_STYLE = {
  width: 124
};
var GREEN_ICON_STYLE = {
  color: '#59C67F'
};
var ORANGE_ICON_STYLE = {
  color: '#FF955A'
};
var TYPES = {
  blue: {
    icon: React.createElement(InfoIcon, {
      className: "primary",
      size: 16
    }),
    style: {
      borderColor: '#5168EC',
      backgroundColor: 'rgba(81,104,236, 0.1)'
    }
  },
  green: {
    icon: React.createElement(CheckboxCheckedIcon, {
      style: GREEN_ICON_STYLE,
      size: 16
    }),
    style: {
      borderColor: '#59C67F',
      backgroundColor: 'rgba(89,198,127, 0.1)'
    }
  },
  orange: {
    icon: React.createElement(WarningIcon, {
      style: ORANGE_ICON_STYLE,
      size: 16
    }),
    style: {
      borderColor: '#FF955A',
      backgroundColor: 'rgba(255,149,90, 0.1)'
    }
  },
  red: {
    icon: React.createElement(CircledCross, {
      className: "red",
      size: 16
    }),
    style: {
      borderColor: '#FF5A6E',
      backgroundColor: 'rgba(255,90,110, 0.1)'
    }
  }
};

function Hint(_ref) {
  var editor = _ref.editor,
      node = _ref.node,
      children = _ref.children,
      readOnly = _ref.readOnly;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      open = _React$useState2[0],
      setOpen = _React$useState2[1];

  var onChange = React.useCallback(function (type) {
    setOpen(false);
    editor.withoutNormalizing(function () {
      node.nodes.forEach(function (child) {
        editor.setNodeByKey(child.key, {
          data: child.data.set('color', type)
        });
      });
    });
  }, [editor, node, setOpen]);
  var onClickOutside = React.useCallback(function () {
    return setOpen(false);
  }, []);
  var onPopoverClick = React.useCallback(function () {
    if (!readOnly) setOpen(true);
  }, [readOnly]);
  var rawType = node.getIn(['nodes', 0, 'data', 'color']) || 'blue';
  var type = TYPES[rawType];
  return React.createElement("div", {
    className: "radius-normal padding-normal flexbox border-left-large shade-05 margin-top-small",
    style: type.style
  }, React.createElement(TinyPopover, {
    isOpen: open,
    align: "start",
    onClickOutside: onClickOutside,
    containerStyle: POPOVER_CONTAINER_STYLE,
    position: "top",
    content: React.createElement("div", {
      className: "flexbox flexbox-align-center background-white radius-normal padding-normal flexbox-space-between shadow--normal",
      style: POPOVER_CONTENT_STYLE
    }, Object.values(TYPES).map(function (_ref2, index) {
      var icon = _ref2.icon;
      return React.createElement("div", {
        key: index,
        onClick: function onClick() {
          return onChange(Object.keys(TYPES)[index]);
        },
        className: "flexbox flexbox-align-center pointer"
      }, icon);
    }))
  }, React.createElement("div", {
    className: classNames('flexbox padding-smaller margin-right-normal margin-top-smallest', {
      pointer: !readOnly
    }),
    style: POPOVER_BUTTON_STYLE,
    onClick: onPopoverClick
  }, type.icon)), React.createElement("div", {
    className: "min-width-zero"
  }, children));
}

export default React.memo(Hint);